exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".address-cascader[data-v-8bb586ec]{width:100%}", ""]);

// exports
